export default class Model
{
	static Key;

	static Cached;

	constructor(props)
	{
		for (let key in props) {
			this[key] = props[key];
		}
	}

	static cancelRequest(prop)
	{
		// if (!this.hasOwnProperty(prop)) {
		// 	throw new Error(
		// 		`Unknown static Request property: ${prop}`
		// 	);
		// }

		if (!this[prop]
			|| !this[prop].isRunning())
		{
			return;
		}

		this[prop].cancel();
		this[prop] = undefined;
	}

	resolve()
	{
		return this;
	}

	static normalize(props)
	{
		return props;
	}

	static make(props)
	{
		if (props instanceof this) {
			return props;
		}

		let model = new this(
			this.normalize(props)
		);

		return model.resolve();
	}

	static makeMany(items)
	{
		let models = [];
		for (let item of items) {
			models.push(
				this.make(item)
			);
		}


		return models;
	}

    /*
    |--------------------------------------------------------------------------
    | Cache
    |--------------------------------------------------------------------------
    */

    static refreshCacheFor(model, cacheName = 'Cached', updateSilently = false)
    {
        let eventName = TB.pluralize(this.Key) +  '@updated';
        // console.log(eventName);

        if (!this[cacheName]) {
        	this[cacheName] = [];
	        console.log('No Cached data');
            // return;
        }

        let updatedModel = this.make({...model});

        this[cacheName] = TB.map([...this[cacheName]], cached => {
            if(cached.id === model.id) {
                return updatedModel;
            }
            return cached
        })

        if (!updateSilently) TB.event(eventName, updatedModel);
        // console.log(updatedModel);
        // console.log(this.Cached);

        return updatedModel;
    }

    static clearCache()
    {
        this.Cached = undefined;
    }
}
